

import { X, Zap, CheckCircle2 } from "lucide-react";

export const Differentiation = () => {
  return (
    <section className="py-32 bg-brand-secondary/30">
       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto space-y-12">
            <h2 className="text-4xl md:text-6xl font-display font-bold tracking-tight">This is not a tool. And not an agency.</h2>
            <div className="grid md:grid-cols-2 gap-8 text-left py-12">
               <div className="glass p-10 rounded-3xl border border-gray-200">
                  <h3 className="text-2xl font-bold mb-4">The Status Quo</h3>
                  <p className="text-gray-500 mb-6">Tools help you manage hiring. <br/>Agencies help you execute hiring.</p>
                  <div className="flex items-center gap-2 text-red-500 font-bold text-sm">
                    <X className="w-4 h-4" /> You manage the gap
                  </div>
               </div>
               <div className="bg-brand-primary text-white p-10 rounded-3xl shadow-2xl relative overflow-hidden">
                  <div className="absolute top-0 right-0 p-4">
                    <Zap className="text-brand-accent fill-brand-accent w-6 h-6" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4">QuantumHire</h3>
                  <p className="text-gray-400 mb-6">QuantumHire does both — a platform-powered recruitment engine built to deliver outcomes.</p>
                  <div className="flex items-center gap-2 text-brand-accent font-bold text-sm">
                    <CheckCircle2 className="w-4 h-4" /> Integrated Sourcing + Screening
                  </div>
               </div>
            </div>
            <p className="text-xl text-gray-500 font-medium italic">Outcome-focused. Tech-enabled. Success-only.</p>
          </div>
       </div>
    </section>
  )
}
